import{ThemeProvider as e}from"@mui/material/styles";import t from"react";import r from"./dark-theme.js";const m=({children:m})=>t.createElement(e,{theme:r},m);export{m as default};
//# sourceMappingURL=dark-theme-provider.js.map
